import { ReactNode } from "react";
import { Box, Divider, Heading, Text } from "@hawkins/components";
import { Colors, Dimensions } from "@hawkins/variables";
import { useTranslation } from "react-i18next";

import { TranslationNamespace } from "../../types";

type SectionHeaderProps = {
  title: string;
  desc?: string;
  children?: ReactNode;
};

export const SectionHeader = ({ title, desc, children }: SectionHeaderProps) => {
  const { t } = useTranslation(TranslationNamespace.LEP);
  return (
    <Box rowGap={Dimensions.Space16} display="grid">
      <Divider />
      <Heading level={1}>{t(title)}</Heading>
      {desc ? <Text>{t(desc)}</Text> : null}
      {children}
      <Text>
        <Text color={Colors.BlackT60} component="span">
          *
        </Text>
        {t('required_field_asterix')}
      </Text>
    </Box>
  );
};
